function FacebookIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.8782 0H4.12146C3.04574 0 2.01407 0.42909 1.25341 1.19287C0.492761 1.95666 0.0654297 2.99257 0.0654297 4.07273V27.9273C0.0654297 29.0074 0.492761 30.0433 1.25341 30.8071C2.01407 31.5709 3.04574 32 4.12146 32H15.7587V18.6854H13.1067V13.3596H15.7367V10.9527C15.7367 8.7744 16.7701 5.3712 21.318 5.3712L25.415 5.38771V9.95069H22.4397C21.956 9.95069 21.2676 10.1926 21.2676 11.2301V13.3599H25.4826L24.9988 18.6857H21.0627V32H27.8782C28.4109 32 28.9383 31.8947 29.4304 31.69C29.9225 31.4853 30.3697 31.1853 30.7463 30.8071C31.1229 30.4289 31.4217 29.98 31.6255 29.4858C31.8294 28.9917 31.9343 28.4621 31.9343 27.9273V4.07273C31.9343 3.53789 31.8294 3.00829 31.6255 2.51416C31.4217 2.02004 31.1229 1.57106 30.7463 1.19287C30.3697 0.814686 29.9225 0.514691 29.4304 0.310018C28.9383 0.105344 28.4109 0 27.8782 0Z"
        fill="white"
      />
    </svg>
  );
}

export default FacebookIcon;
